import * as types from "./mutation-types";

export default {
  [types.SET_LOGIN_USERNAME](state, username) {
    state.username = username;
  },
  [types.SET_LOGIN_FULLNAME](state, { firstName, lastName }) {
    state.firstName = firstName;
    state.lastName = lastName;
  },
  [types.SET_LOGIN_AVATAR_URL](state, avatarUrl) {
    state.avatarUrl = avatarUrl;
  },
  [types.SET_LOGIN_EXTRA_INFO](
    state,
    { phoneNumber, gender, birthday, subscribed, firstName, lastName }
  ) {
    state.firstName = firstName;
    state.lastName = lastName;
    state.phoneNumber = phoneNumber;
    state.gender = gender;
    state.birthday = birthday;
    state.subscribed = subscribed;
  },
  [types.RESET_LOGIN_EXTRA_INFO](state) {
    state.firstName = null;
    state.lastName = null;
    state.phoneNumber = null;
    state.gender = null;
    state.birthday = null;
    state.subscribed = null;
    state.avatarUrl = null;
  },
  [types.SET_CURRENT_USER](state, user) {
    state.user = user;
  },
  [types.RESET_CURRENT_USER](state) {
    state.user = null;
  },
};
